@if (spinner) {
<app-spinner></app-spinner>
}
<div class="inner-page-header">
  <h3>{{ pageTitle }}</h3>
</div>
<div class="request-control" #goUp>
  <div class="right-side">
    @if (filterData) {
    <app-filter
      [filterData]="filterData"
      [filterDataInit]="filterDataInit"
      [filterPage]="filterPage"
      (formValus)="filterFormValues($event)"
    >
    </app-filter>
    }
    <dynamic-columns [filterPage]="gridIdentifier"></dynamic-columns>
    <quick-search
      [placeholder]="' البحث برقم الطلب ,اسم الفاحص ,اسم العميل ...  '"
      (searchResults)="quickSearch($event)"
    ></quick-search>
  </div>
  <div class="left-side">
    <order-status-menu
      [selectedRowsPK]="selectedRowsPK"
      [isTotalRowsSelected]="isTotalRowsSelected"
      [selectedQuery]="selectedQuery"
      [isB2B]="false"
      (changedOrder)="updateOrderStatus($event)"
    ></order-status-menu>
    <add-order></add-order>
    <orders-management
      [selectedRowsPK]="selectedRowsPK"
      [assignedInspectorId]="assignedInspectorId"
      [isTotalRowsSelected]="isTotalRowsSelected"
      [selectedQuery]="selectedQuery"
      [isB2B]="false"
      [pageIdentifier]="'individual'"
      (updateOrders)="getOrdersByPage()"
      (sipnnerState)="sipnnerState($event)"
    >
    </orders-management>
  </div>
</div>
<div class="saved-filters">
  <saved-filters></saved-filters>
</div>
<!-- request table -->
@if (orders.length > 0) {
<div class="request-table">
  <ayen-selected-count
    [itemsPerPage]="currentItemsPerPage"
    [selectedRows]="selectedRowsPK"
    [totalRowsSelected]="isTotalRowsSelected"
    [pageTitle]="pageTitle"
    [totalItems]="config.totalItems"
    (setTotalRowsSelected)="selectTotalRows($event)"
  >
  </ayen-selected-count>
  <div class="table-responsive">
    <ayen-table
      [tableData]="orderData"
      [paginationConfig]="config"
      [initialOrdering]="filterParamsUrl?.ordering"
      (disabledDelete)="disabledDeleteBtn($event)"
      (checkedRow)="getSelectedRow($event)"
      (sortingCol)="toggleSorting($event)"
      [pageUrl]="'/pages/orders/'"
    >
    </ayen-table>
  </div>
</div>
} @if (orders && orders.length > 0) {
<ayen-pagination
  (pageData)="pageChanged($event)"
  (pageSize)="pageSizeChanged($event)"
  [totalCount]="config.totalItems"
  [pageTitle]="pageTitle"
  [itemsPerPage]="config.itemsPerPage"
  (pageChange)="changeToSpecific($event)"
  [currentPage]="config.currentPage"
>
</ayen-pagination>
}
